<template>
  <v-main>
    <OperationDetailsDialog ref="detailsDialog" />

    <GenericReport
      ref="report"
      orientation="horizontal"
      hide-header
      class="clean-list"
      :reportSpec="reportSpec"
      @rowClicked="showRowDetails"
    />
  </v-main>
</template>

<script>
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import OperationDetailsDialog from '../clients/operations/OperationDetailsDialog.vue'

export default {
  pageTitle: 'Medição de Serviços',
  components: {
    GenericReport,
    OperationDetailsDialog
  },
  data() {
    return {
      reportSpec: {
        code: 'billingItems',
        title: 'Medição de Serviços',
        apiBase: '/billing-items',
        filters: [
          { type: 'CostCenter', emptyMeansAll: true },
          { type: 'DateRange' }
        ],
        orderByOptions: ['timestamp desc'],

        sidebarFilters: [
          { type: 'Technician', showInMenu: true },
          { type: 'Org', showInMenu: true },
          {
            type: 'Text',
            prefix: 'clientIds',
            label: 'Módulos',
            showInMenu: true,
            debounceMs: 400
          },
          // {
          //   type: 'Text',
          //   prefix: 'techControl',
          //   label: 'Número de Controle',
          //   showInMenu: true,
          //   debounceMs: 400
          // }
        ]
      }
    }
  },
  methods: {
    async showRowDetails({ row }) {
      // Abre o dialog de detalhe de ClientHistory (não mais
      // de ServiceBI). Esse dialog possui, entre outras infos,
      // os dados de billing (centro de custo, técnico, valores,
      // etc)
      await this.$refs.detailsDialog.open(row.historyId)
    }
  }
}
</script>

<style scoped></style>
